var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEolicoActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_3363",
    "data-name": "Rettangolo 3363",
    width: 17,
    height: 24.293,
    fill: "#90d300"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Eolico2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eolico2",
    clipPath: "url(#clip-Eolico2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_32930",
    "data-name": "Raggruppa 32930",
    transform: "translate(5 1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26733",
    "data-name": "Tracciato 26733",
    d: "M16.845,13.6a2.123,2.123,0,0,0-.438-.449l-.369-.313-.477-.406-.556-.473-.6-.513-.619-.527-.6-.514-.559-.475-.482-.41-.375-.319L11.529,9l-.069-.058a1.347,1.347,0,0,0-.631-.2,1.606,1.606,0,0,0-.2-.482,1.216,1.216,0,0,0,.2-.344c.007-.038.016-.075.025-.113.022-.1.046-.208.069-.313.034-.159.069-.319.1-.477l.134-.606.154-.7c.055-.251.111-.5.165-.754l.17-.772c.056-.252.111-.5.166-.756.052-.234.1-.469.156-.7l.133-.613.108-.488c.023-.109.047-.217.069-.326.01-.042.018-.085.025-.129a1.024,1.024,0,0,0-.262-.932A.9.9,0,0,0,11.66.03a.942.942,0,0,0-1.006.392A2.1,2.1,0,0,0,10.412,1c-.049.153-.1.307-.145.461q-.095.3-.188.6-.11.348-.22.7-.119.378-.238.755c-.081.258-.164.517-.244.775s-.16.5-.239.756l-.22.7-.19.6c-.049.156-.1.312-.148.469-.03.1-.062.2-.093.3-.008.029-.018.057-.026.085a1.37,1.37,0,0,0,.013.493,1.655,1.655,0,0,0-.742.784,1.253,1.253,0,0,0-.249,0L7.369,8.5l-.312.074-.477.114-.6.144L5.284,9l-.75.18-.77.184-.751.181-.7.168L1.7,9.855l-.486.117-.323.078c-.042.01-.085.022-.126.035a1.02,1.02,0,0,0-.725.643.9.9,0,0,0-.028.435.94.94,0,0,0,.791.732,2.04,2.04,0,0,0,.627-.034l.478-.07.619-.092.722-.106.782-.116.8-.118.785-.116.726-.107.626-.093.486-.072.307-.046.089-.013a1.36,1.36,0,0,0,.267-.113L7.3,22.7H6.676a.8.8,0,0,0,0,1.6h4.869a.8.8,0,0,0,0-1.6H11.12l-.8-11.536.3.216.507.358.582.413.631.445.644.457.631.447.588.415.513.362.408.287c.091.064.182.129.274.192.034.026.072.049.109.072a1.023,1.023,0,0,0,.961.122.9.9,0,0,0,.345-.266.942.942,0,0,0,.03-1.079M8.9,22.7l.309-4.462.31,4.462ZM9.232,8.85a.291.291,0,1,1-.291.291.291.291,0,0,1,.291-.291m1.019-3.5-.515,2.23a1.6,1.6,0,0,0-.188-.055ZM5.416,10.107l2.239-.513c.019.064.034.129.059.19Zm5.22-.114a1.719,1.719,0,0,0,.093-.173l1.733,1.494Z",
    transform: "translate(0 0)",
    fill: "#90d300"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEolicoActive);
export default __webpack_public_path__ + "static/media/Eolico_active.7a52130a79ddbe1ebdbe325767e54563.svg";
export { ForwardRef as ReactComponent };